import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  Link,
  Typography
} from '@one-thd/sui-atomic-components';

const BreadcrumbItem = ({ item, inverseText = false }) => {
  const {
    text, href, isLinkable, showSeparator, separator,
    isInternetNumber, isEventDimension, creativeIconUrl
  } = item;

  return (
    <div
      className={classNames(
        'breadcrumb__item',
        'sui-inline',
        'sui-p-0',
        'sui-float-none',
        {
          'sui-text-primary': isInternetNumber && !inverseText,
          'sui-text-inverse': inverseText,
          'sui-font-bold': isEventDimension,
          'breadcrumb__item--pipe': isEventDimension
        }
      )}
    >
      {showSeparator && (
        <div aria-hidden="true" className="sui-inline sui-px-2">
          {separator}
        </div>
      )}

      {isInternetNumber && text}

      {!isInternetNumber && creativeIconUrl && (
        <div
          className={classNames(
            'sui-mr-1',
            'sui-h-4',
            'sui-w-4',
            'sui-bg-contain',
            'sui-bg-center',
            'sui-bg-no-repeat',
            'sui-inline-block',
            'sui-align-text-bottom'
          )}
          style={{ backgroundImage: `url(${creativeIconUrl})` }}
        />
      )}

      {!isInternetNumber && isLinkable && (
        <Link
          href={href}
          color={inverseText ? 'inverse' : 'subtle'}
          className={inverseText ? 'focus-visible:sui-bg-focus focus-visible:sui-outline-none' : undefined}
        >
          {text}
        </Link>
      )}

      {!isInternetNumber && !isLinkable && (
        <Typography component="span" color={inverseText ? 'inverse' : 'subtle'}>{text}</Typography>
      )}
    </div>
  );
};

BreadcrumbItem.displayName = 'BreadcrumbItem';

BreadcrumbItem.propTypes = {
  inverseText: PropTypes.bool,
  item: PropTypes.shape({
    text: PropTypes.string,
    href: PropTypes.string,
    isLinkable: PropTypes.bool,
    showSeparator: PropTypes.bool.isRequired,
    separator: PropTypes.string.isRequired,
    isInternetNumber: PropTypes.bool.isRequired,
    isEventDimension: PropTypes.bool.isRequired,
    creativeIconUrl: PropTypes.string
  }).isRequired
};

export { BreadcrumbItem };